import { MutationOptions, useMutation } from '@tanstack/react-query';
import { CancellationReasonsService } from '../services';
import { ISubmitCancellationFeedbackPayload, ISubmitCancellationFeedbackResult } from '../types';

export const useSubmitCancellationFeedback = (
  options?: MutationOptions<
    ISubmitCancellationFeedbackResult,
    Error,
    ISubmitCancellationFeedbackPayload,
    unknown
  >,
) => {
  return useMutation<ISubmitCancellationFeedbackResult, Error, ISubmitCancellationFeedbackPayload>({
    mutationFn: async (payload: ISubmitCancellationFeedbackPayload) => {
      return CancellationReasonsService.submitCancellationFeedback(payload);
    },
    ...options,
  });
};
